/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

/**
 * Custom useSelectedStudio
 * @param props
 */
export function useSelectedStudio(props) {
  const {
    setCurrentSelectedMarker,
    studioUrls,
    studio,
  } = props;

  const [buttonDisabled, setButtonDisabled] = useState(null);
  const [studioUrl, setStudioUrl] = useState(null);

  useEffect(() => {
    if (studioUrls && studioUrls[studio.id]) {
      setButtonDisabled(false);
      setStudioUrl(studioUrls[studio.id]);
    } else {
      setButtonDisabled(true);
    }
  }, [studio.id, studioUrls]);

  /**
     * Handle the click on the close button and close the selected marker detail overlay
     */
  const handleCloseStudioDetails = () => {
    setCurrentSelectedMarker(false);
  };

  /**
   * Handles the click on the studio button and opens a new browser tab
   */
  const handleLinkToStudio = () => {
    if (studioUrl) {
      window.open(studioUrl, '_blank');
    }
  };

  return {
    handleCloseStudioDetails,
    handleLinkToStudio,
    buttonDisabled,
  };
}

useSelectedStudio.propTypes = {
  setCurrentSelectedMarker: PropTypes.func.isRequired,
  studioUrls: PropTypes.object.isRequired,
  studio: PropTypes.object.isRequired,
};
